import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { Section, SectionHeading, P, PD, A } from './BlogShared.jsx';

/* ─── Social proof stats ─── */
const stats = [
  { value: '73%', label: 'of restaurants lack real-time inventory visibility' },
  { value: '₹18K+', label: 'wasted monthly from overproduction' },
  { value: '4.2 hrs', label: 'spent weekly reconciling data manually' },
];

export const HeroSection = ({ onCTA }) => (
  <Section sx={{ pt: { xs: 5, md: 7 }, pb: { xs: 4, md: 8 } }}>
    {/* Centered text block */}
    <Box sx={{ textAlign: 'center', maxWidth: 820, mx: 'auto', mb: { xs: 5, md: 7 } }}>
      {/* Badge */}
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 0.7,
          borderRadius: '50px',
          background: `${P}08`,
          border: `1px solid ${P}12`,
          mb: 4,
        }}
      >
        <Box sx={{ width: 6, height: 6, borderRadius: '50%', background: A }} />
        <Typography sx={{ fontSize: '0.78rem', fontWeight: 600, color: A, letterSpacing: '0.02em' }}>
          AI Powered growth engine for restaurants
        </Typography>
      </Box>

      {/* Headline */}
      <Typography
        component="h1"
        sx={{
          fontSize: { xs: '2.4rem', sm: '3.2rem', md: '4rem', lg: '4.5rem' },
          fontWeight: 300,
          fontFamily: "'Inter', sans-serif",
          lineHeight: 1.1,
          letterSpacing: '-0.035em',
          color: PD,
          mb: 3,
        }}
      >
        Your restaurant doesn't need another tool.
        <br />
        It needs an{' '}
        <Box
          component="span"
          sx={{
            fontFamily: "'Instrument Serif', serif",
            fontWeight: 700,
            fontStyle: 'italic',
            background: `linear-gradient(135deg, ${P}, ${A})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          edge.
        </Box>
      </Typography>

      {/* Sub-headline — trimmed for mobile clarity */}
      <Typography
        sx={{
          fontSize: { xs: '1.05rem', md: '1.25rem' },
          fontWeight: 400,
          color: 'rgba(0,0,0,0.55)',
          lineHeight: 1.7,
          maxWidth: 620,
          mx: { xs: 0, md: 'auto' },
          mb: 3,
        }}
      >
        Know what to do <em>tomorrow</em> — not just what happened yesterday.
      </Typography>

      {/* Moat pills — bubble badges in 2 rows */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1.5,
          justifyContent: 'center',
          alignItems: 'center',
          maxWidth: 340,
          mx: { xs: 'auto', md: 'auto' },
          mb: 5,
        }}
      >
        {['Inventory', 'Waste', 'Demand', 'Staff', 'Accounting'].map((item) => (
          <Box
            key={item}
            sx={{
              px: 2.2,
              py: 0.9,
              borderRadius: '50px',
              background: `${A}08`,
              border: `1.5px solid ${A}30`,
              fontSize: '0.8rem',
              fontWeight: 600,
              color: A,
              letterSpacing: '0.01em',
              whiteSpace: 'nowrap',
            }}
          >
            {item}
          </Box>
        ))}
      </Box>

      {/* CTA row */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
        <Box
          onClick={onCTA}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            px: 4,
            py: 1.8,
            borderRadius: '14px',
            background: PD,
            color: '#fff',
            fontWeight: 700,
            fontSize: '0.95rem',
            cursor: 'pointer',
            boxShadow: `0 4px 24px ${PD}40`,
            transition: 'all 0.3s cubic-bezier(.16,1,.3,1)',
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: `0 10px 36px ${PD}50`,
            },
          }}
        >
          Get Started Free <ArrowForward sx={{ fontSize: 17 }} />
        </Box>
      </Box>
    </Box>
  </Section>
);
